import { CoreStore } from '../../../../core/store/core.store';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { getLoggedInUser } from '@ppl/auth';
import type { AuthUser } from '@ppl/auth';
import type { Observable } from 'rxjs';

@Component({
  selector: 'ppl-top-navigation',
  templateUrl: './top-navigation.component.html',
  styleUrls: ['./top-navigation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class TopNavigationComponent {
  screenName: '';
  loggedInUser$: Observable<AuthUser> = this.store.select(getLoggedInUser);

  constructor(
    private store: CoreStore
  ) { }
}
